/*
 * A blank CSV template for an import kind, headed with the field labels the
 * server matches on (routes/import_schemas.py). The UTF-8 byte-order mark makes
 * Excel open Hebrew headers correctly.
 */
export function csvCell(value) {
  const text = value === null || value === undefined ? '' : String(value);
  return /[",\n\r;]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

export function templateCsv(fields, language) {
  const header = fields.map(f => csvCell(language === 'he' ? f.label_he : f.label_en)).join(',');
  // \uFEFF, written as an escape: as a raw character it is invisible
  // in every editor and diff, and the next person to touch this line
  // cannot see that it is load-bearing.
  return `\uFEFF${header}\r\n`;
}

export function columnLetter(index) {
  let n = index + 1;
  let out = '';
  while (n > 0) {
    const r = (n - 1) % 26;
    out = String.fromCharCode(65 + r) + out;
    n = Math.floor((n - 1) / 26);
  }
  return out;
}

export function downloadText(filename, text, type = 'text/csv;charset=utf-8') {
  if (typeof window === 'undefined' || !window.URL?.createObjectURL) return false;
  const url = window.URL.createObjectURL(new Blob([text], { type }));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
  return true;
}
